import DirectoryIcon from './DirectoryIcon';
export default DirectoryIcon;
